import { Box, styled } from '@mui/material';

export const StyledWrapper = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.divider,
  '.crud-panel-wrapper': {},
  '.MuiTableCell-head': {
    background: '#F7F7F7 !important',
  },
  '.MuiTableRow-root:nth-of-type(even)': {
    '.MuiTableCell-root': {
      background: '#F8F9FC !important',
    },
  },
  '.MuiTableContainer-root': {
    maxHeight: '700px',
  },
}));

export const ExpandGroupWrapper = styled(Box)(() => ({
  position: 'absolute',
  bottom: '34px',
  width: '100%',
  marginLeft: '-12px',
}));

export const ExpandWrapper = styled(Box)(() => ({
  padding: '8px 0 8px 12px',
  borderBottom: '1px solid',
  borderColor: '#EDECED',
}));
